<!--
 * @Author: cmchiu
 * @Date: 2022-05-30 16:16:46
 * @LastEditTime: 2023-07-06 16:08:30
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\views\calendar\schedule.vue
 * 
-->
<template>
    <div class="schedule">
        <section class="section-right-shape padding-bottom padding-top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mt-20">
                        <breadcrumb />
                    </div>

                    <FullCalendar class="demo-app-calendar" :options="calendarOptions">
                        <template v-slot:eventContent="arg">
                            <el-popover
                                placement="top-start"
                                :title="eventRange(arg.event)"
                                width="250"
                                :visible-arrow="false"
                                trigger="click"
                                popper-class="popoverStyle"
                            >
                                <template #title>Popover Title</template>
                                <i class="title">{{ arg.event.title }}</i>
                                <!-- <el-button @click="more">
                                    更多
                                </el-button> -->

                                <div slot="reference" class="popper-content">
                                    <b>{{ arg.timeText }}</b>
                                    <i>{{ arg.event.title }}</i>
                                </div>
                            </el-popover>
                        </template>
                    </FullCalendar>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/vue'
import twLocale from '@fullcalendar/core/locales/zh-tw'
import dayGridPlugin from '@fullcalendar/daygrid'
// import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import { getEventList } from '@/api/campus'
import { breadcrumb } from '@c/Breadcrumb'

export default {
    name: 'schedule',

    components: { FullCalendar, breadcrumb },

    data: function () {
        return {
            calendarOptions: {
                height: 600,
                locale: twLocale,
                plugins: [
                    dayGridPlugin,
                    // timeGridPlugin,
                    listPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                headerToolbar: {
                    left: 'prev,today,next',
                    center: 'title',
                    right: 'dayGridMonth,listMonth',
                },
                buttonText: {
                    // 按钮的文本设置
                    prev: '上個月',
                    next: '下個月',
                    today: '今日',
                },
                initialView: 'dayGridMonth',
                // initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
                events: this.getEvents,
                fixedWeekCount: false, // 在月視圖中，呈現6周（不夠的顯示下個月的日期）
                showNonCurrentDates: true, // 在月視圖中，是否應該呈現上個月或下個月的日期
                // editable: true,
                // selectable: true,
                // selectMirror: true,
                dayMaxEventRows: true,
                dayMaxEvents: true,
                // select: this.handleDateSelect,
                // eventClick: this.handleEventClick,
                // eventsSet: this.handleEvents,
                /* you can update a remote database when these fire:
                eventAdd:
                eventChange:
                eventRemove:
                */
                eventColor: '#2D9698',
            },
        }
    },

    created: function () {},

    methods: {
        getEvents(info) {
            // function( fetchInfo: { start, end, startStr, endStr, timeZone }, successCallback, failureCallback )
            return new Promise(resolve => {
                let params = {
                    year: info.end.getFullYear(),
                    month: info.end.getMonth() === 0 ? 12 : info.end.getMonth(),
                }
                getEventList(params).then(res => {
                    if (res.Code === 1) {
                        let events = []
                        XEUtils.arrayEach(res.Items, item => {
                            let endDate = new Date(item.EndDate)
                            let endDate_AllDay = endDate.setTime(endDate.getTime() + 1000 * 60 * 60 * 24) // 結束日期補滿24小時
                            let event = {
                                id: item.BoardID,
                                title: item.TitleC,
                                start: XEUtils.toDateString(item.StartDate, 'yyyy-MM-dd'),
                                end: XEUtils.toDateString(endDate_AllDay, 'yyyy-MM-dd'),
                            }

                            events.push(event)
                        })

                        resolve(events)
                    }
                })
            })
        },

        eventRange(event) {
            const start = event.start
            const end = new Date(event.end - 86400000)
            let range = (end - start) / 1000 / 60 / 60 / 24 // 毫秒/秒/分鐘/小時
            let eventRange =
                range > 1
                    ? `${XEUtils.toDateString(start, 'yyyy/M/d')} ~ ${XEUtils.toDateString(end, 'yyyy/M/d')}`
                    : XEUtils.toDateString(start, 'yyyy/M/d')

            return eventRange
        },
    },
}
</script>

<style lang="scss">
.popoverStyle {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 50%);

    .el-popover__title {
        border-bottom: 1px dashed #666;
        color: #666;
        text-align: center;
        font-weight: bold;
        font-family: monospace;
    }

    i.title {
        font-style: normal;
    }
}
</style>

<style scoped lang="scss">
::v-deep .fc-toolbar {
    .fc-toolbar-chunk {
        button {
            width: unset;
            height: unset;
            outline: unset;
        }
    }
}
::v-deep .fc-view-harness {
    table {
        line-height: unset;
        thead {
            a {
                color: #0e2c53;
            }
        }
        tbody {
            .fc-daygrid-event-harness {
                line-height: 1.5;
            }
            a {
                color: #0e2c53;
            }
        }
    }
}
::v-deep .el-popover__reference-wrapper {
    line-height: 1.5;
}
</style>
